// extracted by mini-css-extract-plugin
export default {"password-icon-wrapper":"MyProfile_password-icon-wrapper__AhaeS","locked":"MyProfile_locked__FRN8P","unlocked":"MyProfile_unlocked__kh6G0"};